/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import { Editor } from '@tiptap/react'
import { FC, memo } from 'react'

import { useNodes } from '../../utils'
import styles from './NodeSelector.module.scss'

import Select from '~elements/SelectV2'
import ArrowIcon from '~icons/arrow.svg'
import { MenuVariant } from '~lib/ui-kit/MenuLayout'
import Option from '~lib/ui-kit/Option'
import Text from '~lib/ui-kit/Text'

interface NodeSelectorProps {
  editor: Editor
}

const NodeSelector: FC<React.PropsWithChildren<NodeSelectorProps>> = ({ editor }) => {
  const { nodes, toggleNode, getActiveNode } = useNodes(editor)
  const { name, label } = getActiveNode()

  const handleNodeChange = (value) => {
    toggleNode(value)
  }

  return (
    <Select
      onChange={handleNodeChange}
      renderIcon={false}
      renderValue={() => (
        <Text className={styles.value}>
          {label} <ArrowIcon />
        </Text>
      )}
      value={name}
      variant="plain"
      menuVariant={MenuVariant.CONTEXT}
    >
      {nodes.map(({ name, label, icon }) => (
        <Option key={name} icon={icon} value={name}>
          {label}
        </Option>
      ))}
    </Select>
  )
}

export default memo(NodeSelector)
